import { AppDispatch, AppStore, RootState } from '@/store';
import { useDispatch, useStore } from 'react-redux';
import { useSelector } from 'react-redux';

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();
